<template>
    <div>
        <BaseSidebar v-if="$route.matched.length == 2 && showSidebar" v-model="showSidebar">
            <SearchModule
                filterOrientation="vertical"
                hideSearch
                :filters="getFilters()"
                v-model="selected"
                v-on:clear:filter="
                    () => {
                        clearFilters();
                        resetPageScroll();
                    }
                "
                class="flex-grow"
                v-on:filter:change="resetPageScroll"
                :hasFiltersChanged="hasFiltersChanged"
            />
        </BaseSidebar>
        <SubLayout v-if="$route.matched.length == 2">
            <SearchModule
                filterOrientation="horizontal"
                slot="top"
                :filters="getFilters()"
                v-model="selected"
                v-on:clear:filter="
                    () => {
                        clearFilters();
                        resetPageScroll();
                    }
                "
                v-on:filter:change="resetPageScroll"
                :hasFiltersChanged="hasFiltersChanged"
            />

            <div slot="mobtop">
                <SearchModule
                    filterOrientation="horizontal"
                    v-model="selected"
                    v-on:clear:filter="
                        () => {
                            clearFilters();
                            resetPageScroll();
                        }
                    "
                    v-on:filter:change="resetPageScroll"
                    :hasFiltersChanged="hasFiltersChanged"
                >
                    <div
                        class="text-center py-2 subheading secondary-color noselect"
                        @click="() => (showSidebar = !showSidebar)"
                    >
                        {{ $t('findjobs.changeFilters') }}
                    </div>
                </SearchModule>
            </div>
            <div class="d-flex flex-row w-100" slot="center">
                <Pagination class="w-100" v-on:onBottom="nextPage" ref="pagination">
                    <PostingModule
                        :data="data"
                        class="mb-3 w-100"
                        :resolveroute="resolveRoute"
                        :isLoading="loading()"
                    ></PostingModule>
                </Pagination>
            </div>
            <div slot="right">
                <EventList
                    v-if="$route.matched.length == 2"
                    :value="events"
                    class="mb-4"
                    :vFairId="this.$route.params.id"
                ></EventList>
            </div>
        </SubLayout>
        <router-view></router-view>
    </div>
</template>

<script>
import CompanyList from '~/shared/CompanyList';
import PostingModule from '~/shared/postingmodule/PostingModule';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import EventList from './components/EventList';
import Pagination from '../../../components/miscellaneous/Pagination';
import MainLayout from '../../../components/layouts/mainlayout/MainLayout';
import SubLayout from '../../../components/layouts/mainlayout/SubLayout';
import BaseSidebar from '../../../components/builders/Base/Sidebar';
import SearchModule from '../../../shared/searchmodule/SearchModule';
import AuthService from '../../../services/AuthService';
import jobFilters, { i18nMap, filterMap } from '~/data/jobFilters';
import emptySelected from '~/utils/emptySelected';
import mapSelectedToFilters from '~/utils/mappers/mapSelectedToFilters';

export default {
    name: 'Jobs',
    components: {
        SearchModule,
        BaseSidebar,
        SubLayout,
        Pagination,
        CompanyList,
        PostingModule,
        ProfileModule,
        EventList,
        MainLayout,
    },
    data() {
        return {
            companies: {},
            jobRequest: undefined,
            selected: null,
            forceFilterUpdate: false,
            showSidebar: false,
            waitForFilterProcessing: true,
        };
    },
    computed: {
        postings() {
            return this.$interfaces.posting.get(
                {
                    reactive: true,
                    ...mapSelectedToFilters(this.selectedFilters),
                    vfair_id: this.$route.params.id,
                    page_size: 25,
                    page: this.page,
                },
                1,
                this.page
            );
        },
        data() {
            return this.postings.data || [];
        },
        page() {
            return this.$interfaces.scrollState.findJobsPage();
        },
        events() {
            if (!this.$route.params.id) {
                return [];
            } else {
                return this.$interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: true,
                }).data;
            }
        },
        filters() {
            return this.isLoggedIn && this.connections.data
                ? [
                      ...jobFilters(),
                      this.filteredConnections.length > 0
                          ? {
                                ...i18nMap('filterNames')('exclude_school_id'),
                                options: [
                                    ...this.connections.data
                                        .filter(it => it.isVerified)
                                        .map(it =>
                                            filterMap(
                                                it.school.subDomain
                                                    ? it.school.subDomain.toUpperCase()
                                                    : this.$t(
                                                          'cts.excludeSchoolIds.unknownSchoolId'
                                                      ),
                                                it.schoolId
                                            )
                                        ),
                                    i18nMap('excludeSchoolIds')('-1'),
                                ],
                            }
                          : null, // Can be null, needs to be filtered
                  ].filter(e => e) // Filters the null values
                : jobFilters();
        },
        isLoggedIn() {
            return AuthService.isLoggedIn();
        },
        connections() {
            return this.$interfaces.university.connection.get({
                reactive: true,
            });
        },
        filteredConnections() {
            return this.connections.data.filter(it => it.isVerified);
        },
        hasFiltersChanged() {
            return false;
            if (this.forceFilterUpdate) {
                this.forceFilterUpdate = false;
                this.clearFilters();
            }

            if (!this.selectedFilters) return false;

            let changed = false;

            let empty = Object.entries(emptySelected(this.filters));

            empty.forEach(([key]) => {
                let temp = this.selectedFilters[key];
                if (temp && Object.entries(temp).length > 0) {
                    changed = true;
                }
            });

            return changed || Boolean(this.selectedFilters['company_names']);
        },
        selectedFilters() {
            if (
                Object.values(this.selected).reduce(
                    (prev, curr) => prev + Object.values(curr).length,
                    0
                ) === 0
            )
                return {};
            else return this.selected;
        },
    },
    methods: {
        resolveRoute(jobAdId) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/jobs/', jobAdId);
            return url;
        },
        loading() {
            return this.postings.loading;
        },
        nextPage() {
            if (this.loading() || this.data.length < 4) {
                return;
            }
            this.$interfaces.scrollState.setFindJobsPage(this.page + 1);
        },
        getFilters() {
            return this.filters;
        },
        clearFilters() {
            this.selected = emptySelected(this.filters);
        },
        resetPageScroll() {
            // Filters changed, need to reset page number and pagination anchors
            this.$interfaces.scrollState.setFindJobsPage(1);
            this.$refs.pagination.resetCurrentAnchor();
        },
        addQueryToFilters() {
            // Adds filters in query to selected
            if (!this.$route.query) {
                this.waitForFilterProcessing = false;
                return;
            }

            const selected = {};
            const query = Object.assign({}, this.$route.query);

            // Adding all filters in query to selected
            for (let filterName in query) {
                if (filterName === 'openLogin') continue;
                if (!selected[filterName]) {
                    selected[filterName] = {};
                }
                const filter = query[filterName];
                if (filter instanceof Array) {
                    filter.forEach(filterValue => {
                        selected[filterName][filterValue] = 1;
                    });
                } else if (filterName === 'query') {
                    selected[filterName] = query[filterName];
                } else {
                    selected[filterName][query[filterName]] = 1;
                }
            }

            // Set selected filters
            this.$nextTick(() => {
                this.selected = {
                    ...this.selected,
                    ...selected,
                };
                this.waitForFilterProcessing = false;
            });
        },
        addFiltersToQuery(filters) {
            const query = {}; // Empty query

            // Add all selected filters to query
            Object.entries(filters).forEach(([filterName, filterObject]) => {
                let filterValues = null;
                // Incase filter is a string (like search query)
                if (typeof filterObject === 'string') {
                    filterValues = filterObject;
                } else {
                    // filterObject is an object, get keys
                    filterValues = Object.keys(filterObject);
                }

                if (filterValues.length > 0) {
                    query[filterName] = filterValues;
                }
            });

            // Update url query
            this.$router.replace({ query });
        },
    },
    watch: {
        filters() {
            if (!this.selected) {
                this.selected = emptySelected(null);
            }
        },
        selected(filters) {
            if (filters) {
                this.addFiltersToQuery(filters);
            }
        },
        queries(newQueries, oldQueries) {
            if (oldQueries && Object.keys(oldQueries).length !== 0) {
                if (Object.keys(newQueries).length === 0) {
                    // Force refresh of filters
                    this.forceFilterUpdate = true;
                }
            }
        },
    },
    created() {
        this.$interfaces.scrollState.setFindJobsPage(1);
        this.selected = emptySelected(this.filters);
    },
    mounted() {
        this.addQueryToFilters();
    },
};
</script>

<style scoped></style>
